import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Box,
  Chip
} from '@mui/material';
import {
  Tag as TagIcon,
  DataObject as DataObjectIcon,
  Edit as EditIcon
} from '@mui/icons-material';

const TagInfoModal = ({ open, onClose, tagInfo, userCompanyId, onEditTag }) => {
  if (!tagInfo) {
    return null;
  }

  const { widget, tagName, tagValue } = tagInfo;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TagIcon color="primary" />
          <Typography variant="h6">Tag Information</Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Table size="small">
          <TableBody>
            {/* Widget Type */}
            <TableRow>
              <TableCell component="th" width="40%">
                <Typography variant="subtitle2" fontWeight="bold">
                  Widget Type
                </Typography>
              </TableCell>
              <TableCell>
                <Chip label={widget.type} size="small" color="primary" variant="outlined" />
              </TableCell>
            </TableRow>

            {/* Widget ID */}
            <TableRow>
              <TableCell component="th">
                <Typography variant="subtitle2" fontWeight="bold">
                  Widget ID
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" fontFamily="monospace">
                  {widget.id}
                </Typography>
              </TableCell>
            </TableRow>

            {/* Tag Name */}
            {tagName && (
              <TableRow>
                <TableCell component="th">
                  <Typography variant="subtitle2" fontWeight="bold">
                    Tag Name
                  </Typography>
                </TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <DataObjectIcon fontSize="small" color="action" />
                    <Typography variant="body2" fontFamily="monospace" fontWeight="600">
                      {tagName}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}

            {/* Current Value */}
            {tagValue !== null && tagValue !== undefined && (
              <TableRow>
                <TableCell component="th">
                  <Typography variant="subtitle2" fontWeight="bold">
                    Current Value
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    label={tagValue}
                    size="small"
                    color="success"
                    sx={{ fontWeight: 'bold', fontFamily: 'monospace' }}
                  />
                </TableCell>
              </TableRow>
            )}

            {/* Position */}
            <TableRow>
              <TableCell component="th">
                <Typography variant="subtitle2" fontWeight="bold">
                  Position (X, Y)
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" fontFamily="monospace">
                  ({widget.x?.toFixed(2)}, {widget.y?.toFixed(2)})
                </Typography>
              </TableCell>
            </TableRow>

            {/* Size */}
            <TableRow>
              <TableCell component="th">
                <Typography variant="subtitle2" fontWeight="bold">
                  Size (W × H)
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" fontFamily="monospace">
                  {widget.width?.toFixed(2)} × {widget.height?.toFixed(2)}
                </Typography>
              </TableCell>
            </TableRow>

            {/* Additional Properties */}
            {widget.properties && Object.keys(widget.properties).length > 0 && (
              <TableRow>
                <TableCell component="th">
                  <Typography variant="subtitle2" fontWeight="bold">
                    Properties
                  </Typography>
                </TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    {Object.entries(widget.properties)
                      .filter(([key]) => !['tagId', 'tagName'].includes(key))
                      .slice(0, 5)
                      .map(([key, value]) => (
                        <Typography
                          key={key}
                          variant="caption"
                          fontFamily="monospace"
                          color="text.secondary"
                        >
                          {key}: {String(value).substring(0, 30)}
                        </Typography>
                      ))}
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between' }}>
        {/* Nokta Düzenle button - only for companyId = 2 */}
        {(userCompanyId === 2 || userCompanyId === '2') && widget.properties?.tagId && onEditTag ? (
          <Button
            onClick={() => onEditTag(widget.properties.tagId)}
            variant="contained"
            color="warning"
            startIcon={<EditIcon />}
          >
            Nokta Düzenle
          </Button>
        ) : <Box />}
        <Button onClick={onClose} variant="contained">
          Kapat
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TagInfoModal;
